import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText } = theme;

export const priceModifier = css`
  margin-left: auto;
  justify-self: flex-end;
  white-space: nowrap;
  ${responsiveText.BODY.SM};
`;

export const priceOperator = css`
  margin-right: ${pxToRem(2)};

  &[data-is-negative='false'] {
    ${responsiveText.HEADING.XS};
  }
`;
